import {
  MiddlewareAPI,
  isRejectedWithValue,
  Middleware,
} from '@reduxjs/toolkit';

import SnackbarUtils from '../utils/SnackbarUtilsConfigurator';

const parseError = (action: any) => {
  if (action.payload && action.payload.data && action.payload.data.message) {
    const error = action.payload.data.message;
    SnackbarUtils.error(error);
  }
};

export const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      parseError(action);
    }
    return next(action);
  };
